function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100",
  height: "54",
  viewBox: "0 0 100 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.129 38.166L0 54h100L64.516 12.833l-35.484 38L16.13 38.166z",
  fill: "#FAF9F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.129 38.166L0 54h100L64.516 12.833l-35.484 38L16.13 38.166z",
  fill: "url(#paint0_linear)"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "hard-light"
  },
  filter: "url(#filter1_i)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.129 38.166L0 54h100L64.516 12.833l-35.484 38L16.13 38.166z",
  fill: "gray"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "29",
  cy: "10",
  r: "10",
  fill: "#FAF9F8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "29",
  cy: "10",
  r: "10",
  fill: "url(#paint1_linear)"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "hard-light"
  },
  filter: "url(#filter3_i)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "29",
  cy: "10",
  r: "10",
  fill: "gray"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: "-2",
  y: "10.833",
  width: "104",
  height: "45.167",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: "1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i",
  x: "0",
  y: "12.833",
  width: "100",
  height: "42.167",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "1.5"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: "-1",
  k3: "1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.25098 0 0 0 0 0.25098 0 0 0 0 0.25098 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_b",
  x: "17",
  y: "-2",
  width: "24",
  height: "24",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: "1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_i",
  x: "19",
  y: "0",
  width: "20",
  height: "21",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "1.5"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: "-1",
  k3: "1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.25098 0 0 0 0 0.25098 0 0 0 0 0.25098 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: "50",
  y1: "12.833",
  x2: "50",
  y2: "54",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BFBFBF",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#BFBFBF",
  stopOpacity: ".3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: "29",
  y1: "0",
  x2: "29",
  y2: "20",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BFBFBF",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#BFBFBF",
  stopOpacity: ".3"
})))));